import { ProfileSettingsService } from 'src/app/services/shared/profile-settings/profile-settings.service';
import { NotificationService } from 'src/app/services/shared/notification/notification.service';
import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { LanguageService } from 'src/app/services/shared/language/language.service';
import { jsonParse } from 'src/app/app.component';
import { ContactUsComponent } from 'src/app/controls/components/contact-us/contact-us.component';
import { SessionService } from 'src/app/services/session/session.service';
import { checkMobileScreen } from 'src/app/controls/functions/functions';
import { Session } from 'src/app/classes/session/session';
import { jsonDeepParse } from 'src/app/functions/shared-functions';
@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {
  session: Session;
  masters;
  status_details: any = {
    status: 1,
    summary: 'Ready...'
  }
  mobile_screen = checkMobileScreen()
  timeout;
  portal_details: any = {};
  logo: any;
  constructor(
    public session_svc: SessionService,
    private dialog: MatDialog,
    private profile_svc: ProfileSettingsService,
    private notification_srv: NotificationService
  ) { }

  ngOnInit() {
    this.loadMasters()
    this.mobile_screen = checkMobileScreen()
    this.session_svc.session.subscribe(res => {
      this.session = res;
    })

    this.notification_srv.notification.subscribe(res => {

      if (this.timeout) {
        clearTimeout(this.timeout);
      }
      if (res && res['success']) {
        this.status_details = res;
        this.status_details['status'] = 1;
        try {
          let el = document.getElementById('tm-popup-notification-window');
          el.style.display = 'block';
          el.innerHTML = res['summary'];
        }
        catch (err) {
        }
        this.timeout = setTimeout(() => {
          this.status_details = {
            summary: 'Ready...'
          }
          try {
            let el = document.getElementById('tm-popup-notification-window');
            el.style.display = 'none';
            el.innerHTML = ''
          }
          catch (err) {
          }
          this.status_details['status'] = 3;
          clearTimeout(this.timeout);
        }, this.status_details.autoDismiss || 5000)
        // this.createAlert(res['title'], res['summary'], res['details'], res['severity'], res['dismissible'], res['autoDismiss'], res['appendToId'])
      }
      else if (res && !res['success']) {
        this.status_details = res;
        this.status_details['status'] = 2;
        try {
          let el = document.getElementById('tm-popup-notification-window')
          el.style.color = "var(--js-red)"
          el.style.display = 'block'
          el.innerHTML = res['summary'];
        }
        catch (err) {
        }
        this.timeout = setTimeout(() => {
          this.status_details = {
            summary: 'Ready...'
          }
          this.status_details['status'] = 3;
          try {
            let el = document.getElementById('tm-popup-notification-window');
            el.innerHTML = ""
            el.style.color = "var(--js-red)";
            el.style.display = 'none'
          }
          catch (err) {
          }
          clearTimeout(this.timeout);
        }, this.status_details.autoDismiss || 5000)
        // this.createAlert(res['title'], res['summary'], res['details'], res['severity'], res['dismissible'], res['autoDismiss'], res['appendToId'])
      }
    })
    // this.getMasters();

  }
  getMasters() {
    // this.master_svc.getIpAddress().subscribe(res => {
    //   if (res) {
    // var retrievedObject = localStorage.getItem('getipobject');
    // this.master_svc.getMasters(jsonParse(retrievedObject)).subscribe(masters => {
    //   if (masters && masters['data']) {
    //     this.masters = masters['data']
    //   }
    // })
    // }
    // },
    //   err => {

    //   })
  }
  

  openEnquiry() {
    const MatDialogRef = this.dialog.open(ContactUsComponent, {
      width: "500px",
      // position: { right: '0' },
      // hasBackdrop: 'static',
      // hasBackdrop: false,

      // panelClass:'signup-class'
      data: this.masters,
      panelClass: "TM-Dialog"

    });
  }

  privacyPolicy(nativeElement) {
    // let lng = (this.language.getCurrentLanguageName().toLowerCase());
    // let a = nativeElement;
    // a.href = "https://www.tallint.jobs/tallint-jobs-privacy-policy-" + lng + ".html"
    // a.target = "_blank"
  }

  termsOfUse(nativeElement) {
    // let lng = (this.language.getCurrentLanguageName().toLowerCase());
    // let a = nativeElement;
    // a.href = "https://www.tallint.jobs/tallint-jobs-terms-of-use-" + lng + ".html"
    // a.target = "_blank"
  }
  openURL(url?) {
    window.open(url, "_blank");
  }
  loadMasters() {
    this.profile_svc.loadDefaultSettings().subscribe(res => {
      if (res && res['data']) {
        res['data'] = jsonDeepParse(res['data'])
        if (res['data'].careerPortalConfig) {
          this.portal_details = res['data'].careerPortalConfig;
          if (this.portal_details && this.portal_details.portalSettings && this.portal_details.portalSettings.banners && this.portal_details.portalSettings.banners.length) {
            this.logo = this.portal_details.portalSettings.banners[0].cdnPath
          }
          else if (res['data'].companyLogo && res['data'].companyLogo != '') {
            let data = jsonDeepParse(res['data'].companyLogo);
            if (data && data.length) {
              this.logo = data[0].cdnPath
            }

          }
        }
        else {
          let data = (res['data'].companyLogo);
          if (data && data.length) {
            this.logo = data[0].cdnPath
          }
        }

      }
    })
  }

  scroll_top(){
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  }

}
